import { map } from 'rxjs';
import type { Observable } from 'rxjs';
import { ServiceBase } from 'services';
import {
  createSupportChatAuthorizationToken,
  createSupportChatGuestAuthorizationToken,
  sendSupportChatRating,
} from 'services/api/proxy-support/inner';
// eslint-disable-next-line no-restricted-imports
import user from 'store/user';

class OnlineSupport extends ServiceBase {
  name = 'online-support';

  createToken$(): Observable<string> {
    return this.call$(
      createSupportChatAuthorizationToken({
        headers: {
          'X-Actor-Type': user.isModelView() ? 'performer' : 'studio',
          'X-Actor-Id': user.data.viewTypeId!,
        },
      }).pipe(map((response) => response.data.data.token))
    );
  }

  createGuestToken$(guestNick: string): Observable<string> {
    return this.call$(
      createSupportChatGuestAuthorizationToken({
        guestNick,
      }).pipe(map((response) => response.data.data.token))
    );
  }

  sendChatRating$(
    adminName: string,
    ratingValue: number,
    ratingText: string,
    conversationId: string
  ): Observable<void> {
    return this.call$(
      sendSupportChatRating(
        {
          adminName,
          ratingValue,
          ratingText,
          conversationId,
        },
        {
          headers: {
            'X-Actor-Type': user.isModelView() ? 'performer' : 'studio',
            'X-Actor-Id': user.data.viewTypeId!,
          },
        }
      ).pipe(map(() => undefined))
    );
  }
}

export default new OnlineSupport();
